var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNsbt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m15.742 2 13.743 13.742c-1.391.655-5.056 1.767-8.59.982-2.122-.472-3.735-1.454-5.246-2.373-1.634-.994-3.149-1.916-5.061-2.043-2.946-.197-4.827-.082-5.4 0L15.742 2zm0 28L2 16.258c1.39-.655 5.055-1.767 8.589-.982 2.122.472 3.734 1.453 5.245 2.373 1.634.994 3.148 1.916 5.06 2.043 2.945.197 4.827.082 5.4 0L15.741 30z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNsbt);
export default __webpack_public_path__ + "static/media/NSBT.2d37136aa0fd8645f08916a20e9ea01b.svg";
export { ForwardRef as ReactComponent };